export const convertBooleanToYesNo = (value: string | number | null | undefined): "Yes" | "No" => {
    if (!value) {
        return "No";
    }
    if (typeof value === "string") {
        if (value.toLowerCase() === "true") {
            return "Yes";
        }
        if (value.toLowerCase() === "false") {
            return "No";
        }
        if (value === "1") {
            return "Yes";
        }
        if (value === "0") {
            return "No";
        }
    }
    if (typeof value === "number") {
        return "Yes";
    }
    if (typeof value === "boolean") {
        return "Yes";
    }

    throw Error("Invalid value");
};
